// Core
import React from 'react';

// Components
import Card from '../../../../components/Card';
import WithIcon from '../../../../components/WithIcon';
import ExpandableContent from '../../../../components/ExpandableContent';
import HtmlWrapper from '../../../../components/HtmlWrapper';

// Styles
import './styles.css';


export const OnlineDetails = (props) => {
    return (
        <Card className="OnlineDetails eventDescription">
            <h2 className="OnlineDetails-cardHeader">Joining Details</h2>

            <WebinarUrl url={props.url} style={{marginBottom: '20px'}} />
            <WebinarDescription description={props.description} />
        </Card>
    );
}

OnlineDetails.defaultProps = {
    url: null,
    description: null,
}

export const WebinarUrl = (props) => {
    if (!props.url || typeof props.url !== 'string') return null;

    let displayUrl = props.url.length > 80 ? `${props.url.slice(0, 80)}...` : props.url;

    return (
        <div style={props.style}>
            <WithIcon icon="external-link" size={15}>
                <a className="webinar-url" href={props.url} target="_blank">
                    {displayUrl}
                </a>
            </WithIcon>
        </div>
    )
}

WebinarUrl.defaultProps = {
    url: null,
    style: {},
}

export const WebinarDescription = (props) => {
    if (!props.description) return null;

    return (
        <div className="webinar-description" style={props.style}>
            <WithIcon icon="info-circle" size={16}>
                <ExpandableContent>
                    <HtmlWrapper html={props.description} />
                </ExpandableContent>
            </WithIcon>
        </div>
    )
}

WebinarDescription.defaultProps = {
    description: null,
    style: {},
}

export default OnlineDetails;
